import { top } from './common/arrays';
import { IMatch } from './common/filters';
import { compareItemsByFuzzyScore, IItemAccessor, prepareQuery, scoreItemFuzzy } from './common/fuzzyScorer';

interface Item {
  label: string;
  description?: string;
  path?: string;
}

interface PickItemHighlights {
  label?: IMatch[];
  description?: IMatch[];
}

interface PickItem {
  label: string;
  description?: string;
  path?: string;
  highlights: PickItemHighlights;
}

class ItemAccessor implements IItemAccessor<Item> {
  public getItemLabel(item: Item): string {
    return item.label;
  }
  public getItemDescription(item: Item): string | undefined {
    return item.description;
  }
  public getItemPath(item: Item): string | undefined {
    return item.path;
  }
}

interface FuzzySearchOptions {
  maxResults?: number;
}

export function fuzzySearch(items: Item[], filter: string, options?: FuzzySearchOptions): PickItem[] {
  const maxResults = options?.maxResults || items.length;

  const query = prepareQuery(filter);

  const labelAccessor = new ItemAccessor();
  const scorerCache = Object.create(null);

  const sortedData = top(
    items,
    (anyPickA, anyPickB) => compareItemsByFuzzyScore(anyPickA, anyPickB, query, true, labelAccessor, scorerCache),
    maxResults
  );

  const filteredPicks: PickItem[] = [];
  for (const item of sortedData) {
    const { score, labelMatch, descriptionMatch } = scoreItemFuzzy(item, query, true, labelAccessor, scorerCache);
    if (!score) {
      // No match
      continue;
    }

    const highlights: PickItemHighlights = {
      label: labelMatch,
      description: descriptionMatch,
    };

    filteredPicks.push({
      ...item,
      highlights,
    });
  }

  return filteredPicks;
}
